// Define an enum for theme types
enum Theme {
  Light = 'light',
  Dark = 'dark',
}

/**
 * Checks if the current theme identifier is valid.
 *
 * @param {string | undefined} currentTheme - The current theme identifier.
 * @returns {boolean} True if the theme identifier is either "light" or "dark", false otherwise.
 */
const isValidCurrentTheme = (currentTheme: string | undefined): boolean =>
  currentTheme === Theme.Light || currentTheme === Theme.Dark;
export default isValidCurrentTheme;
